import { render, staticRenderFns } from "./border-avatar.vue?vue&type=template&id=0a9ab277&scoped=true&"
import script from "./border-avatar.vue?vue&type=script&lang=js&"
export * from "./border-avatar.vue?vue&type=script&lang=js&"
import style0 from "./border-avatar.vue?vue&type=style&index=0&id=0a9ab277&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ab277",
  null
  
)

export default component.exports